import { CART_MODULE } from "@/api_framework/api_config";
import { ICartUpdatePayload, ICartUpdateResponse } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});

export const useUpdateCartDetailsAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (cartPayload: ICartUpdatePayload, cartType: "normal" | "hd") => {
      try {
        dispatch(
          setLoading({
            key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
            status: true,
          }),
        );

        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        // `any`: success returns cart data (null-valued today), failure null, stale a marker object.
        const response: any = await axios
          .put(`${CART_MODULE?.CART_DETAILS?.baseURL}`, cartPayload, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICartUpdateResponse>) => {
            if (res.data.status === true) {
              dispatch(
                setLoading({
                  key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                  status: false,
                }),
              );
              return res.data.data;
            } else {
              dispatch(
                setLoading({
                  key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                  status: false,
                }),
              );
              return null;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                status: false,
              }),
            );
            // Stale-screen rejection. Distinct marker so callers can SKIP the follow-up
            // delete (the paired old-line removal) — success returns null data, so we
            // can't infer "rejected" from falsiness alone.
            const errData: any = e?.response?.data;
            if (e?.response?.status === 400 && errData?.data?.stale_sync_version) {
              return { stale_sync_version: true };
            }
            return null;
          });
        return response;
      } catch (e) {
        dispatch(
          setLoading({
            key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
            status: false,
          }),
        );
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
